import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

type Props = {
    value: string
    disabled?: boolean
    onChange: (event: any) => void
    placeholder: string
    className?: string
}

export default function LabelInput({ value, disabled, onChange, placeholder, className }: Props) {
    return (
        <Input
            disabled={disabled}
            value={value}
            onChange={onChange}
            className={cn(
                "h-[44px] flex-1 px-[5px] text-[#424242] dark:text-white border-0 rounded-none rounded-tr-[10px] rounded-br-[10px] focus-visible:ring-0 focus-visible:ring-offset-0 bg-transparent placeholder:text-gray-400",
                disabled && "opacity-50 cursor-not-allowed",
                className
            )}
            placeholder={placeholder}
        />
    )
}





